document.addEventListener("DOMContentLoaded", function () {
  // =========================
  // Mobile Menu
  // =========================

  function updateMobileDialogARIA() {
    const submenuHolders = document.querySelectorAll(".submenu-holder");
    const babyMenus = document.querySelectorAll(".babymenu");
    const isMobile = window.matchMedia("(max-width: 1025px)").matches;

    submenuHolders.forEach((holder) => {
      if (isMobile) {
        holder.setAttribute("role", "dialog");
        holder.setAttribute("aria-modal", "true");
      } else {
        holder.removeAttribute("role");
        holder.removeAttribute("aria-modal");
      }
    });

    babyMenus.forEach((menu) => {
      if (isMobile) {
        menu.setAttribute("role", "dialog");
        menu.setAttribute("aria-modal", "true");
      } else {
        menu.removeAttribute("role");
        menu.removeAttribute("aria-modal");
      }
    });
  }

  updateMobileDialogARIA();
  window.addEventListener("resize", updateMobileDialogARIA);

  // =========================
  // accordian btn complex image
  // =========================

  const buttons = document.querySelectorAll(".complex-accordion-btn");

  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const expanded = this.getAttribute("aria-expanded") === "true";
      const content = this.nextElementSibling;

      this.setAttribute("aria-expanded", !expanded);

      if (content) {
        content.hidden = expanded;
      }
    });
  });

  // // =========================
  // // empty ul/ol/li
  // // =========================
  document.querySelectorAll("ul, ol, li").forEach(function (el) {
    if (el.textContent.trim() === "") {
      el.remove();
    }
  });

  // =========================
  // aria-hidden on <br> <hr>
  // =========================

  document.querySelectorAll("br").forEach((br) => {
    br.setAttribute("aria-hidden", "true");
  });

  document.querySelectorAll("hr").forEach((hr) => {
    hr.setAttribute("aria-hidden", "true");
  });

  // =========================
  // expanded collapsed
  // =========================

  function updateAccordionState() {
    document
      .querySelectorAll(
        ".js-accordion-tab-toggle.js-accordion-tab-toggle--main",
      )
      .forEach((toggle) => {
        const parentItem = toggle.closest(".store-selector-item");

        if (!parentItem) return;

        const isActive = parentItem.classList.contains(
          "store-selector-item--active",
        );

        toggle.setAttribute("aria-expanded", isActive ? "true" : "false");
      });
  }

  // Run on load
  updateAccordionState();

  // Run after clicks if class changes dynamically
  document.addEventListener("click", function () {
    setTimeout(updateAccordionState, 0);
  });

  // =========================
  // Third party warning
  // =========================

  const warningText =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";
        if (!alt.includes(warningText)) {
          img.setAttribute("alt", alt ? alt + ", " + warningText : warningText);
        }
        return;
      }

      if (link.classList.contains("et_pb_button")) {
        link.removeAttribute("aria-label");

        if (!link.querySelector(".visually-hidden")) {
          const span = document.createElement("span");
          span.className = "visually-hidden";
          span.textContent = warningText;
          link.appendChild(span);
        }
        return;
      }

      const text = link.textContent.trim();
      if (!text) return;

      const aria = link.getAttribute("aria-label");
      if (!aria || !aria.includes(warningText)) {
        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =========================
  // Email & phone labels
  // =========================

  document
    .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
    .forEach(function (el) {
      const href = el.getAttribute("href");
      if (
        el.getAttribute("role") === "button" ||
        el.classList.contains("button") ||
        el.classList.contains("btn")
      ) {
        return;
      }

      if (href && href.startsWith("mailto:")) {
        const email = href.replace("mailto:", "").trim();
        const existing = el.getAttribute("aria-label");

        if (existing) {
          el.setAttribute("aria-label", existing + ", Email address: " + email);
        } else {
          el.setAttribute("aria-label", "Email address: " + email);
        }
      }

      // TEL
      if (href && href.startsWith("tel:")) {
        const text = el.textContent.trim();
        const existing = el.getAttribute("aria-label");

        if (existing) {
          el.setAttribute("aria-label", existing + ", Phone number: " + text);
        } else {
          el.setAttribute("aria-label", "Phone number: " + text);
        }
      }
    });

  // =========================
  // Click based menu
  // =========================

  const isDesktop = window.matchMedia("(min-width: 1025px)");

  function initDesktopMenu() {
    const style = document.createElement("style");
    style.textContent = `
    /* Support BOTH Hover and Click (.active) */
    .site-nav.style--classic .has-submenu:hover .submenu,
    .site-nav.style--classic .has-submenu.focus .submenu,
    .site-nav.style--classic .submenu-is-mega-menu.focus .submenu,
    .site-nav.style--classic .has-submenu.active .submenu {
      opacity: 1 !important;
      visibility: visible !important;
    }
    .site-nav.style--classic .has-submenu:hover .submenu:after,
    .site-nav.style--classic .has-submenu.focus .submenu:after,
    .site-nav.style--classic .submenu-is-mega-menu.focus .submenu:after,
    .site-nav.style--classic .has-submenu.active .submenu:after {
      height: calc(100% - var(--header-vertical-space) / 2);
    }
    .site-nav.style--classic .has-submenu:hover .submenu .submenu-holder,
    .site-nav.style--classic .has-submenu.focus .submenu .submenu-holder,
    .site-nav.style--classic .submenu-is-mega-menu.focus .submenu .submenu-holder,
    .site-nav.style--classic .has-submenu.active .submenu .submenu-holder {
      opacity: 1;
      transform: translateY(0);
    }
    /* Baby Menu Support */
    .site-nav.style--classic .submenu.normal-menu .has-babymenu:hover .babymenu,
    .site-nav.style--classic .submenu.normal-menu .has-babymenu.focus .babymenu,
    .site-nav.style--classic .submenu.normal-menu .has-babymenu.active .babymenu {
      opacity: 1 !important;
      visibility: visible !important;
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 101%);
    }
    .site-nav.style--classic .submenu.normal-menu .has-babymenu:hover .babymenu li,
    .site-nav.style--classic .submenu.normal-menu .has-babymenu.focus .babymenu li,
    .site-nav.style--classic .submenu.normal-menu .has-babymenu.active .babymenu li {
      opacity: 1;
      transform: translateY(0);
    }
  `;
    document.head.appendChild(style);

    const menuLinks = document.querySelectorAll(
      ".site-nav .has-submenu > a, .site-nav .has-babymenu > a",
    );

    menuLinks.forEach(function (link) {
      const controlledId = link.getAttribute("aria-controls");
      link.setAttribute("aria-expanded", "false");
      if (controlledId) {
        const submenu = link.parentElement.querySelector(
          ":scope > ul.submenu, :scope > .babymenu",
        );
        if (submenu) {
          submenu.setAttribute("id", controlledId);
        }
      }
    });

    menuLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        if (!window.matchMedia("(min-width: 1025px)").matches) return; // extra runtime guard

        e.preventDefault();
        const parentLi = link.parentElement;
        const isExpanded = link.getAttribute("aria-expanded") === "true";

        if (!parentLi || !parentLi.parentElement) return;

        const siblings = Array.from(parentLi.parentElement.children).filter(
          function (item) {
            return (
              item !== parentLi &&
              (item.classList.contains("has-submenu") ||
                item.classList.contains("has-babymenu"))
            );
          },
        );
        siblings.forEach(function (sibling) {
          sibling.classList.remove("active");
          const siblingLink = sibling.querySelector(":scope > a");
          if (siblingLink) siblingLink.setAttribute("aria-expanded", "false");
          const siblingPanel = sibling.querySelector(".submenu, .babymenu");
          if (siblingPanel) siblingPanel.setAttribute("aria-hidden", "true");
        });

        const panel = parentLi.querySelector(".submenu, .babymenu");
        if (isExpanded) {
          link.setAttribute("aria-expanded", "false");
          parentLi.classList.remove("active");
          if (panel) panel.setAttribute("aria-hidden", "true");
        } else {
          link.setAttribute("aria-expanded", "true");
          parentLi.classList.add("active");
          if (panel) panel.setAttribute("aria-hidden", "false");
        }
      });
    });

    const submenus = document.querySelectorAll(
      ".site-nav .submenu, .site-nav .babymenu",
    );
    submenus.forEach(function (submenu) {
      submenu.addEventListener("focusout", function () {
        if (!window.matchMedia("(min-width: 1025px)").matches) return;
        const parentLi = submenu.closest("li.has-submenu, li.has-babymenu");
        setTimeout(function () {
          const newFocus = document.activeElement;
          if (
            parentLi &&
            !submenu.contains(newFocus) &&
            !parentLi.contains(newFocus) &&
            !newFocus.closest(".submenu, .babymenu")
          ) {
            parentLi.classList.remove("active");
            submenu.setAttribute("aria-hidden", "true");
            const triggerLink = parentLi.querySelector(":scope > a");
            if (triggerLink) triggerLink.setAttribute("aria-expanded", "false");
          }
        }, 50);
      });

      submenu.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    });

    document.addEventListener("click", function (e) {
      if (!window.matchMedia("(min-width: 1025px)").matches) return;
      if (!e.target.closest(".site-nav")) closeAllMenus();
    });

    document.addEventListener("keydown", function (e) {
      if (!window.matchMedia("(min-width: 1025px)").matches) return;
      if (e.key === "Escape") closeAllMenus();
    });
  }
  function closeAllMenus() {
    document
      .querySelectorAll(".site-nav .has-submenu, .site-nav .has-babymenu")
      .forEach(function (item) {
        item.classList.remove("active");
      });
    document
      .querySelectorAll(
        ".site-nav .has-submenu > a, .site-nav .has-babymenu > a",
      )
      .forEach(function (link) {
        link.setAttribute("aria-expanded", "false");
      });
  }

  if (isDesktop.matches) {
    initDesktopMenu();
  }

  isDesktop.addEventListener("change", function (e) {
    if (e.matches) {
      initDesktopMenu();
    } else {
      closeAllMenus();
    }
  });

  // =========================
  // search overlay fix
  // =========================

  const searchForms = document.querySelectorAll(
    "#search-search, #search-mobile",
  );
  const searchOverlay = document.querySelector(".search-results-overlay");

  function openOverlay() {
    if (searchOverlay) searchOverlay.classList.add("active");
  }

  function closeOverlay() {
    if (searchOverlay) searchOverlay.classList.remove("active");
  }

  function isInsideSearchForm(target) {
    return (
      target.closest("#search-search") !== null ||
      target.closest("#search-mobile") !== null
    );
  }

  searchForms.forEach(function (searchForm) {
    if (!searchForm) return;

    var searchInput = searchForm.querySelector(
      "input[type='search'], input[type='text'], input",
    );

    searchForm.addEventListener("focusin", function () {
      openOverlay();
    });

    if (searchInput) {
      searchInput.addEventListener(
        "touchstart",
        function (e) {
          e.stopPropagation();
          openOverlay();
        },
        { passive: true },
      );

      searchInput.addEventListener("focus", function () {
        openOverlay();
      });
    }

    searchForm.addEventListener("focusout", function () {
      setTimeout(function () {
        if (!searchForm.contains(document.activeElement)) {
          closeOverlay();
        }
      }, 30);
    });
  });

  document.addEventListener(
    "touchstart",
    function (e) {
      if (!isInsideSearchForm(e.target)) {
        closeOverlay();
      }
    },
    { passive: true },
  );

  document.addEventListener("click", function (e) {
    if (!isInsideSearchForm(e.target)) {
      closeOverlay();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeOverlay();
      // Return focus to the active search input
      searchForms.forEach(function (searchForm) {
        var input = searchForm.querySelector("input");
        if (input && document.activeElement === input) {
          input.blur();
        }
      });
    }
  });

  // =========================
  // swipper slider accessibility fix
  // =========================
  function updateAriaHidden() {
    const slides = document.querySelectorAll(".swiper .swiper-slide");

    slides.forEach((slide) => {
      const isVisible = slide.classList.contains("swiper-slide-visible");

      slide.setAttribute("aria-hidden", isVisible ? "false" : "true");

      slide
        .querySelectorAll("a, button, input, select, textarea, [tabindex]")
        .forEach((el) => {
          if (isVisible) {
            if (el.hasAttribute("data-old-tabindex")) {
              const oldTabindex = el.getAttribute("data-old-tabindex");

              if (oldTabindex === "") {
                el.removeAttribute("tabindex");
              } else {
                el.setAttribute("tabindex", oldTabindex);
              }

              el.removeAttribute("data-old-tabindex");
            }
          } else {
            if (!el.hasAttribute("data-old-tabindex")) {
              el.setAttribute(
                "data-old-tabindex",
                el.getAttribute("tabindex") || "",
              );
            }

            el.setAttribute("tabindex", "-1");
          }
        });
    });
  }

  updateAriaHidden();

  document.addEventListener("transitionend", function (e) {
    if (e.target.closest(".swiper")) {
      updateAriaHidden();
    }
  });

  document.addEventListener("click", function (e) {
    if (
      e.target.closest(".swiper-button-next") ||
      e.target.closest(".swiper-button-prev") ||
      e.target.closest(".swiper-pagination")
    ) {
      setTimeout(updateAriaHidden, 100);
    }
  });

  const swiper = document.querySelector(".swiper");

  if (swiper) {
    const observer = new MutationObserver(function () {
      updateAriaHidden();
    });

    observer.observe(swiper, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  const overlay = document.querySelector(".search-results-overlay");

  if (overlay) {
    overlay.addEventListener("focusout", function () {
      setTimeout(() => {
        if (!overlay.contains(document.activeElement)) {
          overlay.classList.remove("active");
        }
      }, 10);
    });
  }

  // =========================
  // Store Selector Focus
  // =========================
  var lastStoreSelectorBtn = null;
  var isStoreSelectorPopupOpen = false;

  var storeSelectorTriggers =
    "#site-store-selector-handle, #site-store-selector-handle-mobile, .product-store-change-loc";

  function getVisibleModalCloseButton() {
    var closeButtons = document.querySelectorAll(".modal-close");

    for (var i = 0; i < closeButtons.length; i++) {
      var btn = closeButtons[i];

      if (
        btn.offsetParent !== null &&
        btn.getAttribute("hidden") === null &&
        btn.getAttribute("aria-hidden") !== "true"
      ) {
        return btn;
      }
    }

    return null;
  }

  function returnFocusToStoreSelector() {
    if (!isStoreSelectorPopupOpen) return;

    isStoreSelectorPopupOpen = false;

    setTimeout(function () {
      if (lastStoreSelectorBtn) {
        lastStoreSelectorBtn.focus();
      } else {
        var defaultBtn = document.querySelector("#site-store-selector-handle");
        if (defaultBtn) defaultBtn.focus();
      }
    }, 300);
  }

  document.addEventListener("click", function (e) {
    var triggerBtn = e.target.closest(storeSelectorTriggers);

    if (!triggerBtn) return;

    lastStoreSelectorBtn = triggerBtn;
    isStoreSelectorPopupOpen = true;

    setTimeout(function () {
      var closeBtn = getVisibleModalCloseButton();

      if (closeBtn) {
        closeBtn.setAttribute("tabindex", "0");
        closeBtn.focus();
      }
    }, 1000);
  });

  document.addEventListener("click", function (e) {
    var closeBtn = e.target.closest(".modal-close");

    if (!closeBtn) return;

    returnFocusToStoreSelector();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    returnFocusToStoreSelector();
  });
  // =========================
  // Tab and Tab Panle
  // =========================
  const tabButtons = Array.from(document.querySelectorAll(".cyb-tab-button"));

  function activateTab(button, moveFocus) {
    const selectedId = button.getAttribute("data-id");

    tabButtons.forEach(function (tab) {
      const isActive = tab.getAttribute("data-id") === selectedId;

      tab.classList.toggle("active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    document.querySelectorAll(".ct-wrapper").forEach(function (panel) {
      const isActive = panel.getAttribute("data-id") === selectedId;

      panel.classList.toggle("active", isActive);

      if (isActive) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "hidden");
      }
    });

    if (moveFocus) {
      button.focus();
    }
  }

  tabButtons.forEach(function (button, index) {
    button.addEventListener("click", function () {
      activateTab(button, false);
    });

    button.addEventListener("keydown", function (e) {
      let newIndex = index;

      if (e.key === "ArrowRight") {
        newIndex = index + 1;
      } else if (e.key === "ArrowLeft") {
        newIndex = index - 1;
      } else if (e.key === "Home") {
        newIndex = 0;
      } else if (e.key === "End") {
        newIndex = tabButtons.length - 1;
      } else {
        return;
      }

      e.preventDefault();

      if (newIndex < 0) {
        newIndex = tabButtons.length - 1;
      }

      if (newIndex >= tabButtons.length) {
        newIndex = 0;
      }

      activateTab(tabButtons[newIndex], true);
    });
  });
  ////Aria-has pop
  document.querySelectorAll(".quick-add-to-cart a").forEach(function (link) {
    link.setAttribute("aria-haspopup", "true");
  });

  // =========================
  // Qucik view focus
  // =========================
  var lastQuickBuyBtn = null;
  var isQuickBuyPopupOpen = false;

  document.addEventListener("click", function (e) {
    var quickBuyBtn = e.target.closest(".product-item__quick-buy a");

    if (!quickBuyBtn) return;

    lastQuickBuyBtn = quickBuyBtn;
    isQuickBuyPopupOpen = true;

    setTimeout(function () {
      var closeBtn = document.querySelector(".product-quick-view__close");

      if (closeBtn) {
        closeBtn.setAttribute("tabindex", "0");
        closeBtn.focus();
      }
    }, 500);
  });

  function returnFocusToQuickBuy() {
    if (!isQuickBuyPopupOpen) return;

    isQuickBuyPopupOpen = false;

    setTimeout(function () {
      if (lastQuickBuyBtn) {
        lastQuickBuyBtn.focus();
      }
    }, 300);
  }

  document.addEventListener("click", function (e) {
    var closeBtn = e.target.closest(".product-quick-view__close");

    if (!closeBtn) return;

    returnFocusToQuickBuy();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    returnFocusToQuickBuy();
  });

  // =========================
  // Empty headings
  // =========================
  setTimeout(function () {
    document
      .querySelectorAll(
        ".product__description h1, .product__description h2, .product__description h3, .product__description h4, .product__description h5, .product__description h6",
      )
      .forEach(function (el) {
        const text = el.textContent.trim();
        const hasMeaningfulMedia = el.querySelector(
          "img, svg, picture, video, iframe",
        );
        const hasAriaLabel = el.getAttribute("aria-label");

        if (!text && !hasMeaningfulMedia && !hasAriaLabel) {
          el.remove();
        }
      });
  }, 100);
  ///

  // =========================
  // MOBILE ONLY
  // =========================
  var lastFocusedButton = null;
  var lastFocusedSubButton = null;

  function initMobileFocusHandlers() {
    $(document).on("click.mobileMenu", ".mobile-menu-button", function () {
      if (!window.matchMedia("(max-width: 1024px)").matches) return;

      setTimeout(function () {
        var $closeBtn = $(".sidebar__close");
        if ($closeBtn.length) {
          $closeBtn.attr("tabindex", 0).focus();
        }
      }, 300);
    });

    $(document).on("click.mobileMenu", ".sidebar__close", function () {
      if (!window.matchMedia("(max-width: 1024px)").matches) return;

      setTimeout(function () {
        var $menuBtn = $(".mobile-menu-button");
        if ($menuBtn.length) {
          $menuBtn.attr("tabindex", 0).focus();
        }
      }, 300);
    });

    $("li.has-submenu > a.menu-link").on("click.mobileMenu", function () {
      if (!window.matchMedia("(max-width: 1024px)").matches) return;

      lastFocusedButton = $(this);
      lastFocusedSubButton = null; // reset

      setTimeout(function () {
        $(
          "li.has-submenu.opened > ul.submenu > div.submenu-holder > li.submenu-back > a",
        )
          .attr("tabindex", 0)
          .focus();
      }, 500);
    });

    $("li.has-babymenu > a.menu-link").on("click.mobileMenu", function () {
      if (!window.matchMedia("(max-width: 1024px)").matches) return;

      lastFocusedSubButton = $(this);

      setTimeout(function () {
        $("li.has-babymenu.opened > div.babymenu > ul > li.submenu-back > a")
          .attr("tabindex", 0)
          .focus();
      }, 500);
    });

    $(document).on("click.mobileMenu", "li.submenu-back > a", function () {
      if (!window.matchMedia("(max-width: 1024px)").matches) return;

      var $backBtn = $(this);
      var inBabymenu = $backBtn.closest("div.babymenu").length > 0;

      setTimeout(function () {
        if (inBabymenu && lastFocusedSubButton) {
          lastFocusedSubButton.attr("tabindex", 0).focus();
          lastFocusedSubButton = null;
        } else if (lastFocusedButton) {
          lastFocusedButton.attr("tabindex", 0).focus();
          lastFocusedButton = null;
        }
      }, 500);
    });

    $(document).on("keydown.mobileMenu", function (e) {
      if (!window.matchMedia("(max-width: 1024px)").matches) return;

      if (e.key === "Escape") {
        var $closeBtn = $(".sidebar__close");
        var $menuBtn = $(".mobile-menu-button");

        if ($closeBtn.length && $closeBtn.is(":visible")) {
          $closeBtn.trigger("click"); // close the drawer
          setTimeout(function () {
            $menuBtn.attr("tabindex", 0).focus();
          }, 300);
        }
      }
    });
  }

  function destroyMobileFocusHandlers() {
    $("li.has-submenu > a.menu-link").off("click.mobileMenu");
    $("li.has-babymenu > a.menu-link").off("click.mobileMenu");
    $(document).off("click.mobileMenu", "li.submenu-back > a");
    $(document).off("click.mobileMenu", ".mobile-menu-button");
    $(document).off("click.mobileMenu", ".sidebar__close");
    $(document).off("keydown.mobileMenu");

    lastFocusedButton = null;
    lastFocusedSubButton = null;
  }

  const mobileQuery = window.matchMedia("(max-width: 1024px)");

  if (mobileQuery.matches) {
    initMobileFocusHandlers();
  }
  mobileQuery.addEventListener("change", function (e) {
    if (e.matches) {
      initMobileFocusHandlers();
    } else {
      destroyMobileFocusHandlers();
    }
  });

  //

  // =========================
  // MOBILE Store Selector
  // =========================
  const isMobileStoreSelector = window.matchMedia("(max-width: 1024px)");

  function initMobileStoreSelector() {
    $(document).on(
      "click.mobileStoreSelector",
      "#site-store-selector-handle-mobile",
      function () {
        if (!window.matchMedia("(max-width: 1024px)").matches) return;

        var $sidebarClose = $(".sidebar__close");
        if ($sidebarClose.length && $sidebarClose.is(":visible")) {
          $sidebarClose.trigger("click");
        }

        var $modal = $("modal-box#modal-store-selector");
        if ($modal.length) {
          $modal.addClass("active").css("display", "");
        }

        setTimeout(function () {
          var $modalClose = $modal.find(".modal-close");
          if (!$modalClose.length) {
            $modalClose = $(".modal-close");
          }
          if ($modalClose.length) {
            $modalClose.attr("tabindex", 0).focus();
          }
        }, 350);
      },
    );

    $(document).on(
      "click.mobileStoreSelector",
      "#modal-store-selector .modal-close",
      function () {
        if (!window.matchMedia("(max-width: 1024px)").matches) return;

        var $modal = $("#modal-store-selector");
        $modal.removeClass("active");

        setTimeout(function () {
          var $trigger = $("#site-store-selector-handle-mobile");
          if ($trigger.length) {
            $trigger.attr("tabindex", 0).focus();
          }
        }, 300);
      },
    );

    $(document).on("keydown.mobileStoreSelector", function (e) {
      if (!window.matchMedia("(max-width: 1024px)").matches) return;

      if (e.key === "Escape") {
        var $modal = $("#modal-store-selector");

        if ($modal.hasClass("active")) {
          $modal.removeClass("active");

          setTimeout(function () {
            var $trigger = $("#site-store-selector-handle-mobile");
            if ($trigger.length) {
              $trigger.attr("tabindex", 0).focus();
            }
          }, 300);
        }
      }
    });
  }

  function destroyMobileStoreSelector() {
    $(document).off(
      "click.mobileStoreSelector",
      "#site-store-selector-handle-mobile",
    );
    $(document).off(
      "click.mobileStoreSelector",
      "#modal-store-selector .modal-close",
    );
    $(document).off("keydown.mobileStoreSelector");
  }

  if (isMobileStoreSelector.matches) {
    initMobileStoreSelector();
  }

  isMobileStoreSelector.addEventListener("change", function (e) {
    if (e.matches) {
      initMobileStoreSelector();
    } else {
      destroyMobileStoreSelector();
    }
  });

  ////

  // =========================
  // Cart quantity focus restore
  // =========================

   document.addEventListener("click", function (event) {
      const cartAction = event.target.closest(
        "#AjaxCartForm .qty-plus, #AjaxCartForm .qty-minus, #AjaxCartForm .remove",
      );

      if (!cartAction) return;

      const cartForm = document.getElementById("AjaxCartForm");
      const cartItem = cartAction.closest("[data-js-cart-item]");

      if (!cartForm || !cartItem) return;

      const itemId = cartItem.dataset.id;
      const isRemove = cartAction.classList.contains("remove");

      const focusSelector = cartAction.classList.contains("qty-plus")
        ? ".qty-plus"
        : ".qty-minus";

      function focusCartHeading() {
        const heading = document.querySelector(".main-cart h1, main h1, h1");

        if (heading) {
          heading.setAttribute("tabindex", "-1");
          heading.focus();
        }
      }

      function restoreCartFocus() {
        if (isRemove) {
          focusCartHeading();
          return;
        }

        const updatedCartForm = document.getElementById("AjaxCartForm");
        if (!updatedCartForm) return;

        const updatedItem = Array.from(
          updatedCartForm.querySelectorAll("[data-js-cart-item]"),
        ).find(function (item) {
          return item.dataset.id === itemId;
        });

        if (!updatedItem) {
          focusCartHeading();
          return;
        }

        const focusElement = updatedItem.querySelector(focusSelector);

        if (focusElement) {
          focusElement.focus();
        } else {
          focusCartHeading();
        }
      }

      cartForm.addEventListener(
        "cart-updated",
        function () {
          setTimeout(restoreCartFocus, 0);
        },
        { once: true },
      );
    });



    // =========================
    // Mobile search hard close
    // =========================

    const mobileSearch = document.getElementById("search-mobile");

    if (mobileSearch) {
      const mobileSearchInput = mobileSearch.querySelector("[data-js-search-input]");
      const mobileSearchResults = mobileSearch.querySelector("[data-js-search-results]");
      const mobileSearchOverlay = document.getElementById("search-results-overlay-mobile");

      function openMobileSearch() {
        if (mobileSearchOverlay) {
          mobileSearchOverlay.classList.add("active");
        }
      }

      function closeMobileSearch() {
        if (mobileSearchOverlay) {
          mobileSearchOverlay.classList.remove("active");
        }

        if (mobileSearchResults) {
          mobileSearchResults.innerHTML = "";
        }
      }

      function isInsideMobileSearch(target) {
        return target && mobileSearch.contains(target);
      }

      if (mobileSearchInput) {
        mobileSearchInput.addEventListener("focus", openMobileSearch);
        mobileSearchInput.addEventListener("input", function () {
          if (mobileSearchInput.value.trim().length > 0) {
            openMobileSearch();
          } else {
            closeMobileSearch();
          }
        });
      }

      mobileSearch.addEventListener("focusout", function () {
        setTimeout(function () {
          if (!mobileSearch.contains(document.activeElement)) {
            closeMobileSearch();
          }
        }, 80);
      });

      document.addEventListener(
        "pointerdown",
        function (event) {
          if (!isInsideMobileSearch(event.target)) {
            closeMobileSearch();
          }
        },
        true,
      );

      document.addEventListener(
        "touchstart",
        function (event) {
          if (!isInsideMobileSearch(event.target)) {
            closeMobileSearch();
          }
        },
        { capture: true, passive: true },
      );

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closeMobileSearch();

          if (mobileSearchInput && document.activeElement === mobileSearchInput) {
            mobileSearchInput.blur();
          }
        }
      });
    }

  // =========================
  // Klaviyo Popup Accessibility Fix
  // =========================
   const isAriaHiddenTrue = ($el) => {
    const ariaHiddenValue = $el ? $el.getAttribute("aria-hidden") : null;
    return ariaHiddenValue === "true";
  };

  const isHTMLElement = (node) => {
    return node.nodeType === Node.ELEMENT_NODE;
  };

  const isModal = (node) => {
    if (node.children.length !== 1) return false;
    const modalContainer = Array.from(node.children[0].classList).some((cls) =>
      cls.startsWith("kl-private-reset")
    );

    return modalContainer;
  };

  const getTopLevelDomElements = () => {
    const body = document.body;

    // Use the children property to get all top-level elements
    const topLevelNodes = Array.from(body.children).filter((node) => {
      if (isHTMLElement(node)) {
        const tagName = node.tagName.toLowerCase();

        console.log("isModal: ", isModal);

        // Filter out specific tags
        return (
          tagName !== "script" &&
          tagName !== "link" &&
          tagName !== "iframe" &&
          tagName !== "style" &&
          !isModal(node)
        );
      }
      return false;
    });

    return topLevelNodes;
  };

  const a11yHideTopLevelElements = () => {
    const $elements = getTopLevelDomElements();

    $elements.forEach(($el) => {
      if (!isAriaHiddenTrue($el)) {
        $el.setAttribute("kl-aria-hidden", "true");
        $el.setAttribute("aria-hidden", "true");
      }
    });
  };

  const a11yShowTopLevelElements = () => {
    const $elements = getTopLevelDomElements();

    $elements.forEach(($el) => {
      if ($el.hasAttribute("kl-aria-hidden")) {
        $el.removeAttribute("kl-aria-hidden");
        $el.removeAttribute("aria-hidden");
      }
    });
  }; 

});
